export const convertSetsToArrays = obj => {
    return Object.keys(obj).reduce((acc, key) => {
        const value = obj[key];
        if (value instanceof Set) {
            acc[key] = Array.from(value);
        } else if (typeof value === 'object' && value !== null && !(value instanceof Array)) {
            acc[key] = convertSetsToArrays(value);
        } else {
            acc[key] = value;
        }
        return acc;
    }, {});
};

export const compareFilters = (filterA, filterB) => {
    return JSON.stringify(convertSetsToArrays(filterA)) === JSON.stringify(convertSetsToArrays(filterB));
};

export const removeEmptyFilters = filters => {
    const tempFilters = { ...filters };
    for (const filterName in filters) {
        const value = filters[filterName];
        if (value === undefined || value === '' || value === null || (value instanceof Set && value.size === 0)) {
            delete tempFilters[filterName];
        }
    }
    return tempFilters;
};
